// Native
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

// Components
import { UiKitComponent } from './ui-kit.component';
import { UiButtonsComponent } from "./ui-buttons/ui-buttons.component";
import { UiLinksComponent } from "./ui-links/ui-links.component";
import { UiCheckboxComponent } from "./ui-checkbox/ui-checkbox.component";
import { UiRadioComponent } from "./ui-radio/ui-radio.component";
import { UiFormsComponent } from "./ui-forms/ui-forms.component";
import { UiTooltipsComponent } from "./ui-tooltips/ui-tooltips.component";
import { UiTablesComponent } from "./ui-tables/ui-tables.component";
import { UiPaginationComponent } from "./ui-pagination/ui-pagination.component";
import { UiBreadcrumbsComponent } from "./ui-breadcrumbs/ui-breadcrumbs.component";
import { UiTabsComponent } from "./ui-tabs/ui-tabs.component";
import { UiDatepickerComponent } from "./ui-datepicker/ui-datepicker.component";
import { UiCustomControlsComponent } from "./ui-custom-controls/ui-custom-controls.component";

// Modules
import { CardModule } from "../../../resources/components/card/card.module";
import { CheckInputModule } from "../../../resources/components/check-input/check-input.module";
import {SharedModule} from "../../../modules/shared.module";
import {InputIconModule} from "../../../resources/components/input-icon/input-icon.module";
import {PaginationModule} from "../../../resources/components/pagination/pagination.module";
import {NgxPopperModule} from "ngx-popper";
import {NgSelectModule} from "@ng-select/ng-select";
import {DaterangePickerModule} from "../../../resources/components/daterange-picker/daterange-picker.module";
import {IconsModule} from "../../../resources/components/icons/icons.module";
import { UiSwitchComponent } from './ui-switch/ui-switch.component';
import {CloudTagsModule} from "../../../resources/components/cloud-tags/cloud-tags.module";
import { UiToastrComponent } from './ui-toastr/ui-toastr.component';
import { UiModalsComponent } from './ui-modals/ui-modals.component';
import {ModalModule} from "ngx-bootstrap/modal";
import {ModalReceiptDetailsModule} from "../../../resources/components/modals/modal-receipt-details/modal-receipt-details.module";
import { UiFormGroupComponent } from './ui-form-group/ui-form-group.component';
import {FormGroupContextModule} from "../../../resources/modules/form-group-context/form-group-context.module";
import {FormGroupSimpleModule} from "../../../resources/modules/form-group-context/form-group-simple/form-group-simple.module";
import {ValidateModule} from "../../../resources/modules/validate/validate.module";
import {FormGroupSelectModule} from "../../../resources/modules/form-group-context/form-group-select/form-group-select.module";
import {FormGroupFilesModule} from "../../../resources/modules/form-group-context/form-group-files/form-group-files.module";
import {FilesInputModule} from "../../../resources/components/files-input/files-input.module";
import {FormGroupDateModule} from "../../../resources/modules/form-group-context/form-group-date/form-group-date.module";
import {BreadcrumbsModule} from "../../../resources/modules/breadcrumbs/breadcrumbs.module";



@NgModule({
  declarations: [
    UiKitComponent,
    UiButtonsComponent,
    UiLinksComponent,
    UiCheckboxComponent,
    UiRadioComponent,
    UiFormsComponent,
    UiTooltipsComponent,
    UiTablesComponent,
    UiPaginationComponent,
    UiBreadcrumbsComponent,
    UiTabsComponent,
    UiDatepickerComponent,
    UiCustomControlsComponent,
    UiSwitchComponent,
    UiToastrComponent,
    UiModalsComponent,
    UiFormGroupComponent
  ],
  imports: [
    CommonModule,
    CardModule,
    ModalModule.forRoot(),
    BreadcrumbsModule,
    ReactiveFormsModule,
    CheckInputModule,
    SharedModule,
    InputIconModule,
    CloudTagsModule,
    PaginationModule,
    NgxPopperModule,
    NgSelectModule,
    FormsModule,
    DaterangePickerModule,
    IconsModule,
    CloudTagsModule,
    ModalReceiptDetailsModule,
    FormGroupContextModule,
    FormGroupSimpleModule,
    ValidateModule,
    FormGroupSelectModule,
    FormGroupFilesModule,
    FilesInputModule,
    FormGroupDateModule,
  ]
})
export class UiKitModule { }
